import { Component } from '@angular/core';

@Component({
  selector: 'v2m-blog-v260',
  templateUrl: './blog-v260.component.html',
  styleUrls: ['./blog-v260.component.scss']
})
export class BlogV260Component {

}
